// extracted by mini-css-extract-plugin
export default {"container":"Login_container__VMeB7","page":"Login_page__1ybUO"};